import { create } from 'zustand';

export type ReportDownloadType = 'pdf' | 'xlsx';

type ReportDownloadState = {
  activeDownload: ReportDownloadType | null;
  // Returns false when another PDF/XLSX download is still running.
  startDownload: (type: ReportDownloadType) => boolean;
  finishDownload: () => void;
};

const useReportDownload = create<ReportDownloadState>((set, get) => ({
  activeDownload: null,
  startDownload: (type) => {
    if (get().activeDownload) {
      return false;
    }
    set({ activeDownload: type });
    return true;
  },
  finishDownload: () => set({ activeDownload: null }),
}));

export default useReportDownload;
